// ─────────────────────────────────────────────────────────────────────────────
// MODULE CODES
// Stable identity for each module. Used as icon lookup key.
// Format: MOD_{SCOPE}_{NAME}
// Never changes even if module name or numeric ID changes.
// Share this file with the backend team — they must include moduleCode in the
// menu API response so the frontend can resolve icons without relying on names.
// ─────────────────────────────────────────────────────────────────────────────

// ── Normal mode ──────────────────────────────────────────────────────────────
export const MOD_APP                    = "MOD_APP";
export const MOD_CATALOGUE              = "MOD_CATALOGUE";
export const MOD_FULFILL                = "MOD_FULFILL";
export const MOD_FINANCE                = "MOD_FINANCE";
export const MOD_REPORTS                = "MOD_REPORTS";
export const MOD_USERS                  = "MOD_USERS";

// ── Settings mode ─────────────────────────────────────────────────────────────
export const MOD_SETTINGS               = "MOD_SETTINGS";        // hidden root
export const MOD_ACCT                   = "MOD_ACCT";            // platformOnly
export const MOD_MOD_PERS               = "MOD_MOD_PERS";        // platformOnly
export const MOD_USR_ACCESS             = "MOD_USR_ACCESS";      // platformOnly
export const MOD_MASTER                 = "MOD_MASTER";          // all users
export const MOD_ACCT_CLIENT            = "MOD_ACCT_CLIENT";     // clientOnly
export const MOD_SUBS_CLIENT            = "MOD_SUBS_CLIENT";     // clientOnly
export const MOD_USR_PROFILE            = "MOD_USR_PROFILE";     // clientOnly
export const MOD_MANAGE_ACCESS_CLIENT   = "MOD_MANAGE_ACCESS_CLIENT"; // clientOnly

// ── Platform mode ─────────────────────────────────────────────────────────────
export const MOD_PLT_CLIENTS            = "MOD_PLT_CLIENTS";     // platformOnly
export const MOD_PLT_MASTER             = "MOD_PLT_MASTER";      // platformOnly
export const MOD_PLT_ACCESS             = "MOD_PLT_ACCESS";      // platformOnly

// ── Client-view mode (platform user inside a client) ─────────────────────────
export const MOD_CV_ACCT                = "MOD_CV_ACCT";         // platformOnly
export const MOD_CV_SUBS                = "MOD_CV_SUBS";         // platformOnly
export const MOD_CV_ACCESS              = "MOD_CV_ACCESS";       // platformOnly

// ─────────────────────────────────────────────────────────────────────────────
// PAGE CODES
// Stable identity for each page. Used for access-control checks.
// Format: {MODULE_SHORT}_{SUBMODULE_SHORT}_{PAGE_HINT}
// Never changes even if the tenant renames the page.
// null = no access restriction (always visible to any authenticated user).
// ─────────────────────────────────────────────────────────────────────────────

// ── Catalogue ─────────────────────────────────────────────────────────────────
export const CAT_PROD_MASTER            = "CAT_PROD_MASTER";
export const CAT_PROD_VARIANTS          = "CAT_PROD_VARIANTS";
export const CAT_PROD_PENDING_ONLINE    = "CAT_PROD_PENDING_ONLINE";
export const CAT_PROD_LIVE_MARKET       = "CAT_PROD_LIVE_MARKET";
export const CAT_PROD_NEW_REQUESTS      = "CAT_PROD_NEW_REQUESTS";
export const CAT_PROMO_LIST             = "CAT_PROMO_LIST";
export const CAT_PROMO_LIVE             = "CAT_PROMO_LIVE";

// ── Fulfillment ───────────────────────────────────────────────────────────────
export const FULFILL_INST_ORDER_DASHBOARD  = "FULFILL_INST_ORDER_DASHBOARD";
export const FULFILL_INST_LEAD_DASHBOARD   = "FULFILL_INST_LEAD_DASHBOARD";
export const FULFILL_INST_CREATE_ORDER     = "FULFILL_INST_CREATE_ORDER";
export const FULFILL_FF_ENQUIRY            = "FULFILL_FF_ENQUIRY";
export const FULFILL_FC_MATERIAL_MOVEMENT  = "FULFILL_FC_MATERIAL_MOVEMENT";
export const FULFILL_FC_MONEY_MOVEMENT     = "FULFILL_FC_MONEY_MOVEMENT";
export const FULFILL_FC_DPP_LEDGER         = "FULFILL_FC_DPP_LEDGER";
export const FULFILL_AUDIT_LOGS            = "FULFILL_AUDIT_LOGS";

// ── Finance ───────────────────────────────────────────────────────────────────
export const FIN_DEPOSIT_CONFIRM           = "FIN_DEPOSIT_CONFIRM";
export const FIN_SALES_COMMISSION          = "FIN_SALES_COMMISSION";

// ── Reports ───────────────────────────────────────────────────────────────────
export const RPT_ORDERS                    = "RPT_ORDERS";
export const RPT_SALES                     = "RPT_SALES";
export const RPT_RETURNS                   = "RPT_RETURNS";
export const RPT_DECLINES_SHIPPER          = "RPT_DECLINES_SHIPPER";
export const RPT_SELLER_REMITTANCE         = "RPT_SELLER_REMITTANCE";

// ── Users & Access ────────────────────────────────────────────────────────────
export const USR_ACCESS_ROLE_CREATE        = "USR_ACCESS_ROLE_CREATE";
export const USR_ACCESS_PAGE_CREATE        = "USR_ACCESS_PAGE_CREATE";
export const USR_ACCESS_PAGE_ACTION        = "USR_ACCESS_PAGE_ACTION";
export const USR_ACCESS_ROLE_ACTION        = "USR_ACCESS_ROLE_ACTION";
export const USR_ACCESS_PAGE_PLT_ROLE      = "USR_ACCESS_PAGE_PLT_ROLE";
export const USR_USERS_ORG                 = "USR_USERS_ORG";
export const USR_USERS_AZ_PARTNER          = "USR_USERS_AZ_PARTNER";
export const USR_USERS_SELLERS             = "USR_USERS_SELLERS";
export const USR_USERS_CUSTOMER            = "USR_USERS_CUSTOMER";
export const USR_USERS_SHIPPERS            = "USR_USERS_SHIPPERS";

// ── Manage Master ─────────────────────────────────────────────────────────────
export const MASTER_LOC_STATE              = "MASTER_LOC_STATE";
export const MASTER_LOC_DISTRICT           = "MASTER_LOC_DISTRICT";
export const MASTER_LOC_SUBDISTRICT        = "MASTER_LOC_SUBDISTRICT";
export const MASTER_LOC_PINCODE            = "MASTER_LOC_PINCODE";
export const MASTER_LOC_VILLAGE            = "MASTER_LOC_VILLAGE";
export const MASTER_LOC_BLOCK              = "MASTER_LOC_BLOCK";
export const MASTER_LOC_MARKET             = "MASTER_LOC_MARKET";
export const MASTER_CAT_CATEGORY           = "MASTER_CAT_CATEGORY";
export const MASTER_CAT_SUBCATEGORY        = "MASTER_CAT_SUBCATEGORY";
export const MASTER_BANK_BANK              = "MASTER_BANK_BANK";
export const MASTER_BANK_BRANCH            = "MASTER_BANK_BRANCH";
export const MASTER_ORG_TYPE               = "MASTER_ORG_TYPE";
export const MASTER_ORG_LEGAL              = "MASTER_ORG_LEGAL";
export const MASTER_NODAL_FC               = "MASTER_NODAL_FC";
export const MASTER_LOC_COUNTRY            = "MASTER_LOC_COUNTRY";
export const MASTER_LOC_BV_MAPPING         = "MASTER_LOC_BV_MAPPING";
